import React, { useState, useEffect } from "react";
import "./RMA.css";
import { NavLink } from "react-router-dom";

const API = "https://suivi.amservices.eu/api";

export default function Rma() {
    const [rmas, setRmas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);

    const loadRmas = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API}/get_rma.php`, { credentials: "include" });
            const data = await res.json();
            if (data.success) setRmas(data.data);
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    useEffect(() => { loadRmas(); }, []);

    const updateField = async (id, field, value) => {
        try {
            await fetch(`${API}/update_rma_field.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ id, field, value })
            });
        } catch (e) {
            console.error("Erreur update:", e);
        }
    };

    const updateEtat = async (id, etat) => {
        await fetch(`${API}/update_etat_rma.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ id, etat })
        });
        loadRmas();
    };

    const addRma = async () => {
        const payload = {
            client_nom: document.getElementById("nomClient").value.trim(),
            client_tel: document.getElementById("telClient").value.trim(),
            materiel: document.getElementById("nomMateriel").value.trim(),
            numero_serie: document.getElementById("numeroSerie").value.trim(),
            constructeur: document.getElementById("constructeur").value.trim(),
            ref_constructeur: document.getElementById("refConstructeur").value.trim(),
            note: document.getElementById("noteRma").value.trim(),
        };

        if (!payload.client_nom || !payload.materiel) return alert("Champs incomplets");

        await fetch(`${API}/add_rma.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify(payload)
        });
        setShowModal(false);
        loadRmas();
    };

    return (
        <div className="admin-page">
            <h1>🔄 Suivi RMA</h1>

            <div className="top-actions">
                <button className="btn-add" onClick={() => setShowModal(true)}>+ Ajouter</button>
                <NavLink to="/rma/archives" className="btn-archive-link">📦 Archives</NavLink>
            </div>

            {loading && <p style={{ textAlign: 'center' }}>Chargement...</p>}

            <table className="repair-table">
                <thead>
                    <tr>
                        <th>Réf</th>
                        <th>Client</th>
                        <th>Matériel / S/N</th>
                        <th>Notes</th>
                        <th>SAV / Réf</th>
                        <th>État</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {rmas.map(r => (
                        <tr key={r.id}>
                            <td data-label="Réf">
                                <span className="ref-badge">{r.reference || `RMA-${r.id}`}</span>
                            </td>
                            <td data-label="Client">
                                <strong>{r.client_nom}</strong><br />
                                <small>{r.client_tel}</small>
                            </td>
                            <td data-label="Matériel / S/N">
                                <span>{r.materiel}</span>
                                <input
                                    className="input-inline"
                                    style={{ marginTop: '8px', fontSize: '0.85rem' }}
                                    defaultValue={r.numero_serie}
                                    onBlur={e => updateField(r.id, 'numero_serie', e.target.value)}
                                    placeholder="S/N"
                                />
                            </td>
                            <td data-label="Notes">
                                <textarea
                                    defaultValue={r.note}
                                    onBlur={e => updateField(r.id, 'note', e.target.value)}
                                    placeholder="Notes..."
                                />
                            </td>
                            <td data-label="SAV / Réf">
                                <span>{r.constructeur}</span><br />
                                <small className="ref-sav-text">Réf: {r.ref_constructeur || "-"}</small>
                            </td>
                            <td data-label="État">
                                <select value={r.etat} onChange={(e) => updateEtat(r.id, e.target.value)}>
                                    <option value="en_attente">En attente</option>
                                    <option value="envoye">Envoyé</option>
                                    <option value="recu">Reçu</option>
                                </select>
                            </td>
                            <td data-label="Actions" className="actions-menu">
                                <button onClick={() => { if (window.confirm("Archiver ce RMA ?")) updateEtat(r.id, 'archive') }} title="Archiver">📦</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* MODAL AJOUT (Reste identique pour tout saisir au départ) */}
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2>Nouveau RMA</h2>
                        <input id="nomClient" placeholder="Nom du client" />
                        <input id="telClient" placeholder="Téléphone" />
                        <input id="nomMateriel" placeholder="Matériel (ex: Laptop Asus)" />
                        <input id="numeroSerie" placeholder="Numéro de série (S/N)" />
                        <input id="constructeur" placeholder="Constructeur / Marque" />
                        <input id="refConstructeur" placeholder="Référence Dossier SAV" />
                        <textarea id="noteRma" placeholder="Notes (problème constaté...)" />
                        <div className="modal-actions">
                            <button className="btn-cancel" onClick={() => setShowModal(false)}>Annuler</button>
                            <button className="btn-submit" onClick={addRma}>Valider</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}